import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('data', 'constants');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'constants',
  type: 'get',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/data/constants.js